import React from 'react'

import useIsAdult from '@/hooks/useIsAdult'
import MinorAgeRestriction from '@/components/organisms/MinorAgeRestriction'

interface AgeVerificationGuardProps {
  children: React.ReactNode
}

const AgeVerificationGuard: React.FC<AgeVerificationGuardProps> = ({ children }) => {
  const { isAdult } = useIsAdult()

  if (isAdult === false) {
    return <MinorAgeRestriction />
  }

  return children as React.ReactElement
}

export default AgeVerificationGuard
